import React, { Component } from 'react';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { Singleton } from '../../js/Singleton';
import { supervisorChatSimpleSVG } from '../../Images/ChatSVG'
import { tacheCirculo } from '../../Images/GenericSVG'

export default class CancelNoAvailableState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noAvailableName: this.props.message.description,
      noAvailableFrame: this.props.message.frame,
      noAvailableID: this.props.message.notReadyId,
      setByAdmin: this.props.message.setByAdmin,
      onHiddeAlert: false,
    }
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.message.action === "notReadyScheduled") {
      this.setState({
        noAvailableName: nextProps.message.description,
        noAvailableFrame: nextProps.message.frame,
        noAvailableID: nextProps.message.notReadyId,
        setByAdmin: nextProps.message.setByAdmin,
      });
    }
  }
  onClickHandler = () => {
    console.log("ONCLICK ");
    this.setState({ onHiddeAlert: true });
    this.props.onCancel(this.state.noAvailableID);
  }
  render() {
    return (
      <div className={"cancelNoAvailableStateContainer " + (this.state.onHiddeAlert ? "onHidde" : "")}>
        <div className="alertAbsolute">
          <div className="iconCancelNA">{this.sharedData.getIconNoAvailable(this.state.noAvailableFrame)}</div>
          <div className="infoCancelNA">
            <p className="titleCancelNA">{this.language.getText("GUIDisableSelectorprogrammed")}</p>
            <p className="nameCancelNA">{this.state.noAvailableName}</p>
          </div>
          {this.state.setByAdmin ?
            <div className="icon16Grey">{supervisorChatSimpleSVG}</div>
            : <div className="divIconCNAS"><div className='tacheIconCNAS' onClick={this.onClickHandler}>{tacheCirculo}</div></div>}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Alerts/CancelNoAvailableState.jsx